import { planSponsoredInsertions } from '../ads/placement';
export function mergeReleaseCampaigns(campaigns) {
  const selected = new Map();
  campaigns.forEach((campaign) => {
    const current = selected.get(campaign.id);
    const region = campaign.albums?.[0]?.displayRegion;
    const preferred =
      region === 'KR'
        ? 'ALBUMS_RELEASES_KR'
        : region === 'GLOBAL'
          ? 'ALBUMS_RELEASES_GLOBAL'
          : null;
    const next = campaign.placements[0],
      old = current?.placements[0];
    if (
      !current ||
      (next.placementKey === preferred && old.placementKey !== preferred) ||
      ((next.placementKey === preferred) === (old.placementKey === preferred) &&
        next.startAfterOrganic < old.startAfterOrganic)
    )
      selected.set(campaign.id, campaign);
  });
  return [...selected.values()];
}
export function insertionSlots(campaign) {
  return planSponsoredInsertions([campaign], Number.MAX_SAFE_INTEGER).map((entry) => entry.at);
}
// Admin stores row-based placements as mobile two-column item counts.
// Keep that API contract, converting only inline grid slots to the rendered width.
const rowPlacements = new Set([
  'ALBUMS_RELEASES_KR',
  'ALBUMS_RELEASES_GLOBAL',
  'ALBUMS_RECOMMENDED',
  'REVIEWS_ALBUMS',
]);
function inlineForColumns(campaign, columns) {
  const p = campaign.placements[0];
  if (!rowPlacements.has(p.placementKey)) return campaign;
  return {
    ...campaign,
    placements: [
      {
        ...p,
        startAfterOrganic: Math.ceil(Math.max(0, p.startAfterOrganic || 0) / 2) * columns,
        repeatEvery: p.repeatEvery
          ? Math.ceil(Math.max(6, p.repeatEvery) / 2) * columns
          : p.repeatEvery,
      },
      ...campaign.placements.slice(1),
    ],
  };
}
export function sponsoredBlocks(items, campaigns, columns = 2) {
  const native = campaigns.filter(
    (c) => c.placements[0]?.format === 'NATIVE_ALBUM' && c.albums?.length,
  );
  const inline = campaigns.filter((c) => c.placements[0]?.format === 'INLINE_BANNER');
  const advertised = new Set(campaigns.flatMap((c) => (c.albums || []).map((a) => a.id)));
  const organic = items.filter((item) => !advertised.has(item.id));
  const nativeSlots = planSponsoredInsertions(native, organic.length),
    inlineSlots = planSponsoredInsertions(
      inline.map((c) => inlineForColumns(c, columns)),
      organic.length,
    );
  const tiles = [];
  for (let at = 0; at <= organic.length; at++) {
    nativeSlots
      .filter((slot) => slot.at === at)
      .forEach((slot) => tiles.push({ kind: 'sponsored', ...slot }));
    if (at < organic.length) tiles.push({ kind: 'organic', item: organic[at] });
  }
  const blocks = [];
  let consumed = 0,
    ad = 0;
  const append = () => {
    while (ad < inlineSlots.length && inlineSlots[ad].at <= consumed)
      blocks.push({ kind: 'inline', ...inlineSlots[ad++] });
  };
  append();
  for (let at = 0; at < tiles.length; at += columns) {
    const row = tiles.slice(at, at + columns);
    blocks.push({ kind: 'row', tiles: row });
    consumed += row.filter((tile) => tile.kind === 'organic').length;
    append();
  }
  while (ad < inlineSlots.length) blocks.push({ kind: 'inline', ...inlineSlots[ad++] });
  return blocks;
}
